import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { NavigationService, NavLocation, NavItem } from 'netview';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { MenuItem, MenuItemCommandEvent } from 'primeng/api';


@Component({
    selector: 'breadcrumbs',
	templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss']

})
export class BreadcrumbComponent {

	onDataChangeSub: Subscription;
	onLocationChangeSub: Subscription;

	items: MenuItem[] = [];  

    
    constructor(private navService: NavigationService) {
        this.onLocationChangeSub = navService.onLocationChanged.subscribe(
            value => this.rebuildBreadcrumbs(),
            error => console.log("FAILED TO REBUILD BREADCRUMBS ON LOCATION CHANGE")            
        );
        this.onDataChangeSub = navService.onLevelsChanged.subscribe(
            value => this.rebuildBreadcrumbs(),
            error => console.log("FAILED TO REBUILD BREADCRUMBS ON DATA CHANGE") 
        );

        this.rebuildBreadcrumbs();
	}

	public ngOnDestroy(): void {
		if (this.onLocationChangeSub) {
			this.onLocationChangeSub.unsubscribe();
			this.onLocationChangeSub = undefined;
		}
		if (this.onDataChangeSub) {
			this.onDataChangeSub.unsubscribe();
			this.onDataChangeSub = undefined;
		}
	}

    private rebuildBreadcrumbs() {   
        this.items = [];
        // For each navigation level
        for (let level of this.navService.levels) {
            var current = {
                label: "",
                command: (event: MenuItemCommandEvent) => { console.log("No command data given for navitem click event") },
                items: []
            };

            // Get all of the data for the level
            for (let item of level.items) {
                var elem = {
                    label: item.label,
                    command: (event: Event) => { this.navigate(item); }
                }

                // Set the text to be equal to the currently selected item
                if (item.selected == true) {
                    current.label = item.label;
                    current.items.unshift(elem);
                }
                else {
                    current.items.push(elem);
                }            
            }
            // Only push to breadcrumbs if there is an active element
            if (current.label != "") {
                this.items.push(current);
            }          
        }
	}

    private navigate(navItem: NavItem): void {
		this.navService.selectItem(navItem);
	}

}